import { all } from "redux-saga/effects";
import { watchTranslateText } from "./translate";

export default function*() {
  yield all([watchTranslateText()]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js